import * as v from 'valibot';

import { vcAccountId, vcAccountNumber, vcBmwOrMiniId, vcGcid, vcVin } from '../../../../../utils/valibot/custom-types';
import { newSchema } from '../../../../../utils/valibot/schema';
import { RetailCrmNationalIdDocumentType } from './national-id-document-type.model';

export const RetailCrmVehicleAddressSchema = newSchema(
  'RetailCrmVehicleAddressSchema',
  v.object({
    addressPostBox: v.optional(v.string()),
    addressStreet: v.optional(v.string()),
    addressStreetNumber: v.optional(v.string()),
    addressPostalCode: v.optional(v.string()),
    addressCity: v.optional(v.string()),
    addressCountry: v.optional(v.string()),
  }),
);

export const RetailCrmOwnerKeeperUserDataSchema = newSchema(
  'RetailCrmOwnerKeeperUserDataSchema',
  v.object({
    accountId: v.optional(vcAccountId),
    accountNumber: v.optional(vcAccountNumber),
    customerMainType: v.optional(v.string()),
    gcid: v.optional(vcGcid),
    bmworMiniId: v.optional(vcBmwOrMiniId),
    salutation: v.optional(v.string()),
    title: v.optional(v.string()),
    firstName: v.optional(v.string()),
    middleName: v.optional(v.string()),
    lastName: v.optional(v.string()),
    suffix: v.optional(v.string()),
    fullName: v.optional(v.string()),
    privateAddress: v.optional(RetailCrmVehicleAddressSchema),
    businessAddress: v.optional(RetailCrmVehicleAddressSchema),
    phonePrivate: v.optional(v.string()),
    phoneBusiness: v.optional(v.string()),
    mobilePrivate: v.optional(v.string()),
    mobileBusiness: v.optional(v.string()),
    emailPrivate: v.optional(v.string()),
    emailBusiness: v.optional(v.string()),
    language: v.optional(v.string()),
    personBirthdate: v.optional(v.string()),
    taxNumber: v.optional(v.string()),
    nationalId1: v.optional(v.string()),
    nationalId1DocumentType: v.optional(v.enum(RetailCrmNationalIdDocumentType)),
    inSyncWithDirectSales: v.optional(v.boolean()),
  }),
);

export const RetailCrmVehicleSchema = newSchema(
  'RetailCrmVehicleSchema',
  v.object({
    id: v.optional(v.string()),
    registrationNumber: v.optional(v.string()),
    vehicleNumber: v.optional(v.string()),
    name: v.string(),
    vin: vcVin,
    orderState: v.optional(v.number()),
    mileage: v.optional(v.number()),
    owner: v.optional(RetailCrmOwnerKeeperUserDataSchema),
    keeper: v.optional(RetailCrmOwnerKeeperUserDataSchema),
    user: v.optional(RetailCrmOwnerKeeperUserDataSchema),
  }),
);

export const RetailCrmVehiclesResponseSchema = newSchema(
  'RetailCrmVehiclesResponseSchema',
  v.array(RetailCrmVehicleSchema),
);

export type RetailCrmVehicleAddress = v.InferOutput<typeof RetailCrmVehicleAddressSchema>;
export type RetailCrmOwnerKeeperUserData = v.InferOutput<typeof RetailCrmOwnerKeeperUserDataSchema>;
export type RetailCrmVehicle = v.InferOutput<typeof RetailCrmVehicleSchema>;
export type RetailCrmVehiclesResponse = v.InferOutput<typeof RetailCrmVehiclesResponseSchema>;
